export enum LabelPositions {
	NoLabel = 0,
	Left = 1,
	UpperLeft = 2,
	UpperMiddle = 3,
	UpperRight = 4,
	Right = 5,
	LeftColon = 6
}